import React, { useState, useEffect,useRef } from "react";
import PropTypes from "prop-types";
import {
  CalendarHeader,
  ModalBody,
  ParticipantsList,
  Participant,
  ImageContainer,
  InviteButtonWrapper,
  InputWrapper,
  StyledInput,
  StyledModal
} from "./style";
import { Divider, NameInitials } from "../../Manager/styles";
import { AdminCloseIcon, RecognitionTickIcon } from "../../../utils/icons";
import { getInitials } from "../../../utils/methods";
import Waiting from "../../Waiting";
import { ImageUrl } from "../../../utils/constants";

const UserInvitePopup = ({
  show,
  onHide,
  title = "Invite Friends",
  userList = [],
  loading = false,
  onSubmit,
  onSearch, 
  fallbackImage,
  isDisabledKey = "is_invited",
  // nameKey = "fullname",
  // profileImageKey = "profile_image",
  buttonText = "Send Invite",
  searchText,
  isRemoveMode,
  isAddMode,
  hasMore = true,          // <-- NEW prop (from parent)
  page = 1,
  t = (val) => val,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    const delayDebounce = window.setTimeout(() => {
      if (onSearch) {
        onSearch(searchInput, 1, true); // reset page to 1 on new search
      }
    }, 500);
    return () => window.clearTimeout(delayDebounce);
  }, [searchInput]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return undefined;

    const handleScroll = () => {
      if (loading || !hasMore) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        onSearch(searchInput, page + 1); // fetch next page
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [page, loading, hasMore, searchInput]);

  const toggleSelect = (userId, disabled) => {
    if (disabled) return;
    setSelectedIds((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const fallBack = (e) => {
    e.target.src = fallbackImage || "/public/images/fallback.png";
  };

  const handleSubmit = () => {
    onSubmit(selectedIds);
    onHide();
  };

  // useEffect(() => {
    
  //   const delayDebounce = window.setTimeout(() => {
  //     if (onSearch) {
  //       onSearch(searchInput); 
  //     }
  //   }, 500);

  //   return () => window.clearTimeout(delayDebounce);
  // }, [searchInput]);

  // const toggleSelect = (userId, disabled) => {
  //   if (disabled) return;

  //   setSelectedIds((prev) =>
  //     prev.includes(userId)
  //       ? prev.filter((id) => id !== userId)
  //       : [...prev, userId]
  //   );
  // };

  // const fallBack = (e) => {
  //   e.target.src = fallbackImage || "/public/images/fallback.png";
  // };

  // const handleSubmit = () => {
  //   onSubmit(selectedIds); 
  //   onHide();
  // };
  

  return (
    <StyledModal show={show} onHide={onHide} padding="25px" width="600px">
      <CalendarHeader padding="0 16px">
        <div className="newTitle">{title}</div>
        <div className="closeButton" onClick={onHide}>
          {AdminCloseIcon()}
        </div>
      </CalendarHeader>

      <Divider id="divider" isMargin="0px 0px 16px 0px" />

      <InputWrapper inputPadding="0px 24px 0px 24px">
        <div className="titleName">{searchText}</div>
        <StyledInput
          isHeight={"36px"}
          placeholder="Search"
          onChange={(e) => setSearchInput(e.target.value)}
          value={searchInput}
          maxLength="100"
          bgColor="white"
        />
      </InputWrapper>

      {/* <ModalBody padding="12px 24px 0px 24px !important">
        <ParticipantsList listHeight="365px" border >
          {loading ? (
            <Waiting />
          ) : userList?.length > 0 ? (
            userList.map((user, id) => {
              const fullName = user.name;
              const disabled = user[isDisabledKey];
              const userId = user.uid;
              const isSelected = selectedIds.includes(userId);
              // Check if the user is already added
              const isAlreadyAttended = user.is_already_attended && isAddMode; 
              const isNotAttended= !user.is_already_attended && isRemoveMode; 

              return (
                <Participant key={id} isPadding={"6px 0px"}  height={"48px"} isAlreadyAdded={isAlreadyAttended || isNotAttended ? "50%" : "100%"}>
                  <div className="profile">
                    {user.profile_image !== "profile-Image/default.png" ? (
                      <ImageContainer width="48px" isRadius={"50%"} isImageWidth={"48px"} isMargin="0px 12px 0px 0px"  isAlreadyAdded={isAlreadyAttended || isNotAttended ? "50%" : "100%"}>
                        <img
                          onError={fallBack}
                          src={`${ImageUrl + "/" + user.profile_image}`}
                          alt={fullName}
                        />
                      </ImageContainer>
                    ) : (
                      <NameInitials isBg={"white"} isAlreadyAdded={isAlreadyAttended || isNotAttended ? "50%" : "100%"} margin={"0 12px 0px 0px"}> {getInitials(fullName)}</NameInitials>
                    )}
                  </div>

                  <div className="nameAndWellnessInterest">
                    <div className="name">
                      {fullName}
                    </div>
                  </div>

                  <div className="checkbox">
                    {isAlreadyAttended ? (
                      <div style={{ color: "#BDBDBD", fontSize: "12px",fontFamily:"Lato" }}>
                      User already attended event
                      </div>
                    ) :
                      isNotAttended  ? (
                        <div style={{ color: "#BDBDBD", fontSize: "12px", fontFamily: "Lato" }}>
                          User did not attend event
                        </div>
                      ) : 
                        (
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              border: isSelected
                                ? "1px solid #F37A65"
                                : "1px solid #7C7C7C",
                              borderRadius: "4px",
                              cursor: disabled ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: disabled ? 0.5 : 1,
                            }}
                            onClick={() => toggleSelect(userId, disabled)}
                          >
                            {isSelected && RecognitionTickIcon()}
                          </div>
                        )}
                  </div>
                </Participant>
              );
            })
          ) : (
            <div style={{ padding: "12px", color: "#666" }}>
              {t("No user found")}
            </div>
          )}
        </ParticipantsList>
      </ModalBody> */}


      <ModalBody padding="12px 24px 0px 24px !important">
        <ParticipantsList ref={scrollRef} listHeight="365px" border>
          {userList?.length > 0 ? (
            userList.map((user, id) => {
              const fullName = user.name;
              const disabled = user[isDisabledKey];
              const userId = user.uid;
              const isSelected = selectedIds.includes(userId);
              const isAlreadyAttended =
                user.is_already_attended && isAddMode;
              const isNotAttended =
                !user.is_already_attended && isRemoveMode;

              return (
                <Participant
                  key={id}
                  isPadding={"6px 0px"}
                  height={"48px"}
                  isAlreadyAdded={
                    isAlreadyAttended || isNotAttended ? "50%" : "100%"
                  }
                >
                  {/* avatar */}
                  <div className="profile">
                    {user.profile_image !== "profile-Image/default.png" ? (
                      <ImageContainer
                        width="48px"
                        isRadius={"50%"}
                        isImageWidth={"48px"}
                        isMargin="0px 12px 0px 0px"
                      >
                        <img
                          onError={fallBack}
                          src={`${ImageUrl + "/" + user.profile_image}`}
                          alt={fullName}
                        />
                      </ImageContainer>
                    ) : (
                      <NameInitials isBg={"white"} isAlreadyAdded={isAlreadyAttended || isNotAttended ? "50%" : "100%"} margin={"0 12px 0px 0px"}> {getInitials(fullName)}</NameInitials>
                    )}
                  </div>

                  {/* name */}
                  <div className="nameAndWellnessInterest">
                    <div className="name">{fullName}</div>
                  </div>

                  {/* checkbox */}
                  <div className="checkbox">
                    {isAlreadyAttended ? (
                      <div style={{ fontSize: "12px", color: "#BDBDBD" }}>
                        User already attended event
                      </div>
                    ) : isNotAttended ? (
                      <div style={{ fontSize: "12px", color: "#BDBDBD" }}>
                        User did not attend event
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          border: isSelected
                            ? "1px solid #F37A65"
                            : "1px solid #7C7C7C",
                          borderRadius: "4px",
                          cursor: disabled ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: disabled ? 0.5 : 1,
                        }}
                        onClick={() => toggleSelect(userId, disabled)}
                      >
                        {isSelected && RecognitionTickIcon()}
                      </div>
                    )}
                  </div>
                </Participant>
              );
            })
          ) : loading ? (
            <Waiting />
          ) : (
            <div style={{ padding: "12px", color: "#666" }}>
              {t("No user found")}
            </div>
          )}
          {/* loader at bottom */}
          {/* {loading && <div style={{ textAlign: "center", padding: "8px", color:"#184A61" }}>Loading...</div>} */}
          {/* {!hasMore && userList.length > 0 && (
            <div style={{ textAlign: "center", padding: "8px" }}>No more users</div>
          )} */}
        </ParticipantsList>
      </ModalBody>

      <InviteButtonWrapper
        NoBorder
        margin
        disabled={selectedIds.length === 0}
        onClick={selectedIds.length === 0 ? null : handleSubmit}
      >
        <div className="inviteButton">{buttonText}</div>
      </InviteButtonWrapper>
    </StyledModal>
  );
};

UserInvitePopup.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string,
  userList: PropTypes.array,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  onSearch: PropTypes.func, // <-- required for API-based search
  fallbackImage: PropTypes.string,
  nameKey: PropTypes.string,
  profileImageKey: PropTypes.string,
  isDisabledKey: PropTypes.string,
  t: PropTypes.func,
  buttonText: PropTypes.string,
  searchText: PropTypes.string,
  isRemoveMode: PropTypes.bool,
  isAddMode: PropTypes.bool,
  hasMore: PropTypes.bool,       // <-- NEW prop
  page: PropTypes.number,        // <-- NEW prop
};

export default UserInvitePopup;
